// Italian provinces (sigla)
export const ITALIAN_PROVINCES = [
  "Agrigento", "Alessandria", "Ancona", "Aosta", "Arezzo", "Ascoli Piceno", "Asti",
  "Avellino", "Bari", "Barletta-Andria-Trani", "Belluno", "Benevento", "Bergamo",
  "Biella", "Bologna", "Bolzano", "Brescia", "Brindisi", "Cagliari", "Caltanissetta",
  "Campobasso", "Caserta", "Catania", "Catanzaro", "Chieti", "Como", "Cosenza",
  "Cremona", "Crotone", "Cuneo", "Enna", "Fermo", "Ferrara", "Firenze", "Foggia",
  "Forlì-Cesena", "Frosinone", "Genova", "Gorizia", "Grosseto", "Imperia", "Isernia",
  "L'Aquila", "La Spezia", "Latina", "Lecce", "Lecco", "Livorno", "Lodi", "Lucca",
  "Macerata", "Mantova", "Massa-Carrara", "Matera", "Messina", "Milano", "Modena",
  "Monza e Brianza", "Napoli", "Novara", "Nuoro", "Oristano", "Padova", "Palermo",
  "Parma", "Pavia", "Perugia", "Pesaro e Urbino", "Pescara", "Piacenza", "Pisa",
  "Pistoia", "Pordenone", "Potenza", "Prato", "Ragusa", "Ravenna", "Reggio Calabria",
  "Reggio Emilia", "Rieti", "Rimini", "Roma", "Rovigo", "Salerno", "Sassari",
  "Savona", "Siena", "Siracusa", "Sondrio", "Sud Sardegna", "Taranto", "Teramo",
  "Terni", "Torino", "Trapani", "Trento", "Treviso", "Trieste", "Udine", "Varese",
  "Venezia", "Verbano-Cusio-Ossola", "Vercelli", "Verona", "Vibo Valentia",
  "Vicenza", "Viterbo"
];

// Common Italian cities for autocomplete
export const ITALIAN_CITIES = [
  "Roma", "Milano", "Napoli", "Torino", "Palermo", "Genova", "Bologna", "Firenze",
  "Bari", "Catania", "Venezia", "Verona", "Messina", "Padova", "Trieste", "Brescia",
  "Parma", "Taranto", "Prato", "Reggio Calabria", "Modena", "Reggio Emilia", "Perugia",
  "Livorno", "Ravenna", "Cagliari", "Foggia", "Rimini", "Salerno", "Ferrara",
  "Sassari", "Latina", "Giugliano in Campania", "Monza", "Siracusa", "Pescara",
  "Bergamo", "Forlì", "Trento", "Vicenza", "Terni", "Bolzano", "Novara", "Piacenza",
  "Ancona", "Andria", "Arezzo", "Udine", "Cesena", "Lecce", "Pesaro", "Barletta",
  "Alessandria", "La Spezia", "Pistoia", "Pisa", "Catanzaro", "Guidonia Montecelio",
  "Lucca", "Brindisi", "Torre del Greco", "Treviso", "Busto Arsizio", "Como",
  "Marsala", "Grosseto", "Sesto San Giovanni", "Pozzuoli", "Varese", "Fiumicino",
  "Casoria", "Asti", "Cinisello Balsamo", "Caserta", "Gela", "Aprilia", "Ragusa",
  "Pavia", "Cremona", "Carpi", "Quartu Sant'Elena", "Lamezia Terme", "Altamura",
  "L'Aquila", "Imola", "Massa", "Trapani", "Viterbo", "Cosenza", "Potenza", "Castellammare di Stabia",
  "Afragola", "Vittoria", "Crotone", "Vigevano", "Caltanissetta", "Matera", "Savona",
  "Benevento", "Cuneo", "Carrara", "Avellino", "Viareggio", "Verbania", "Sondrio"
];

// Countries (subset)
export const COUNTRIES = [
  "Italia", "Austria", "Belgio", "Bulgaria", "Cipro", "Croazia", "Danimarca",
  "Estonia", "Finlandia", "Francia", "Germania", "Grecia", "Irlanda", "Lettonia",
  "Lituania", "Lussemburgo", "Malta", "Paesi Bassi", "Polonia", "Portogallo",
  "Regno Unito", "Repubblica Ceca", "Romania", "Slovacchia", "Slovenia", "Spagna",
  "Svezia", "Svizzera", "Stati Uniti", "Canada", "Brasile", "Argentina", "Cina",
  "Giappone", "India", "Australia", "Nuova Zelanda"
];
